import { APP_CONSTANTS } from '../constants/app'

export function calculateFee(numberOfSports: number): number {
  if (numberOfSports === 0) return 0
  return (
    APP_CONSTANTS.BASE_FEE +
    (numberOfSports - 1) * APP_CONSTANTS.ADDITIONAL_SPORT_FEE
  )
}

export function formatFee(fee: number): string {
  return `₹${fee.toLocaleString('en-IN')}`
}
